import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from '@wix/wix-i18n-config';

import { Invalid } from './components/invalid/invalid';
import { i18n } from './i18n';
import { fedops } from './fedops';

fedops.appLoadStarted();

const config = window.__CONFIG__;
const i18nInstance = i18n(config.locale);

ReactDOM.render(
  <Suspense fallback="">
    <I18nextProvider i18n={i18nInstance}>
      <Invalid />
    </I18nextProvider>
  </Suspense>,
  document.getElementById('root'),
);
